import { render, staticRenderFns } from "./StrategyProjectsHeader.vue?vue&type=template&id=518da00b&scoped=true"
import script from "./StrategyProjectsHeader.vue?vue&type=script&lang=js"
export * from "./StrategyProjectsHeader.vue?vue&type=script&lang=js"
import style0 from "./StrategyProjectsHeader.vue?vue&type=style&index=0&id=518da00b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518da00b",
  null
  
)

export default component.exports